import { NgModule } from '@angular/core';
import { TimeLimitService } from './time-limit.service';

@NgModule({
    providers: [TimeLimitService],
})
export class TimeLimitModule {}
